import { UserMeasurementPreviewListDto } from '@web/common';
import { z } from 'zod';
import { publicAPI } from '../../../requests';
import { measurementData } from '../stores';

export const requestMeasurementList = async (kcToken: string) => {
  // TODO: CBYN-187 Fix this endpoint to validate
  return await publicAPI.get<UserMeasurementPreviewListDto>(
    `/user/measurements`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${kcToken}`,
      },
    },
  );
};

export const requestMeasurementData = async (
  measurementId: string,
  kcToken: string,
) => {
  return await publicAPI.get(
    `/measurement/report/${measurementId}`,
    measurementData,
    {
      headers: {
        Authorization: `Bearer ${kcToken}`,
      },
    },
  );
};

export const requestMeasurementDataWithToken = async (paymentToken: string) => {
  return await publicAPI.get(`/measurement/report`, measurementData, {
    headers: {
      'Payment-Token': paymentToken,
    },
  });
};

export const requestFormulaUpdateExecution = async (kcToken: string) => {
  return await publicAPI.post(
    `/user/measurements/recalculate-outdated`,
    {},
    z.boolean(),
    {
      headers: {
        Authorization: `Bearer ${kcToken}`,
      },
    },
  );
};
